import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-3 w-full animate-slideFadeIn" }
const _hoisted_2 = { class: "flex items-start gap-2 w-full mt-2 px-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-red-500 mt-1 w-full"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-red-500 w-full"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "text-center text-sm text-gray-500" }

import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import * as Yup from 'yup'
import { useForm, useField } from 'vee-validate'
import FormInput from './FormInput.vue'
import axios from "@/services/api";

import { useRoute } from "vue-router"
import { setOnboardingToken } from '@/lib/signupVault'

export default /*@__PURE__*/_defineComponent({
  __name: 'SignUpForm',
  setup(__props) {

const route = useRoute()
const role = route.params.role as 'creator' | 'brand'
const allowedRoles = ['creator', 'brand']
onMounted(() => {
    if (!role || !allowedRoles.includes(role)) {
        router.replace('/auth/choose')
    }
})

const router = useRouter()

const passwordStrengthSchema = Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .max(24, 'Password must be at most 24 characters')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[^A-Za-z0-9]/, 'Password must contain at least one special character')
    .test('no-spaces', 'Password cannot contain spaces', value => !/\s/.test(value ?? ''))

const schema = Yup.object({
    email: Yup.string().required('Email is required').email('Email is invalid'),
    password: passwordStrengthSchema.required('Password is required'),
    confirmPassword: Yup.string()
        .required('Please confirm your password')
        .oneOf([Yup.ref('password')], 'Passwords must match'),
    agree: Yup.boolean()
        .oneOf([true], 'You must accept the Terms & Conditions')

})
const signupError = ref('')
const { handleSubmit } = useForm({ validationSchema: schema })
const { value: email, errorMessage: emailError, meta: emailMeta } = useField<string>('email')
const { value: password, errorMessage: passwordError, meta: passwordMeta } = useField<string>('password')
const { value: confirmPassword, errorMessage: confirmPasswordError, meta: confirmPasswordMeta } = useField<string>('confirmPassword')
const { value: agree, errorMessage: agreeError } = useField<boolean>('agree')

const handleSignUp = handleSubmit(async () => {
    if (!role || !allowedRoles.includes(role) || !agree.value) return
    try {
        const res = await axios.post('user/create-onboarding-session', {
            email: email.value,
            password: password.value,
            role,
        })
        setOnboardingToken(res.data.onboardingToken, role, email.value)
        router.push(`/onboarding/${role}`)
    } catch (e: any) {
        signupError.value = e.response?.data?.message || 'Something went wrong. Please try again.'
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-3xl font-semibold text-gray-600 text-center pb-12" }, " Welcome to TAWA ", -1)),
    _createVNode(FormInput, {
      label: "Email",
      modelValue: _unref(email),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
      type: "email",
      placeholder: "Enter your email address",
      error: _unref(emailMeta).touched ? _unref(emailError) : ''
    }, null, 8, ["modelValue", "error"]),
    _createVNode(FormInput, {
      label: "Password",
      modelValue: _unref(password),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
      type: "password",
      placeholder: "Enter your password",
      error: _unref(passwordMeta).touched ? _unref(passwordError) : ''
    }, null, 8, ["modelValue", "error"]),
    _createVNode(FormInput, {
      label: "Confirm Password",
      modelValue: _unref(confirmPassword),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null)),
      type: "password",
      placeholder: "Confirm your password",
      error: _unref(confirmPasswordMeta).touched ? _unref(confirmPasswordError) : ''
    }, null, 8, ["modelValue", "error"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: "agree",
        type: "checkbox",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(agree) ? (agree).value = $event : null)),
        class: "mt-1 h-4 w-4 rounded border-gray-300 text-purple-500"
      }, null, 512), [
        [_vModelCheckbox, _unref(agree)]
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("label", {
        for: "agree",
        class: "text-sm text-gray-500 leading-relaxed"
      }, [
        _createTextVNode(" I agree to the "),
        _createElementVNode("a", {
          href: "https://tawa.digital/privacy-policy/",
          target: "_blank",
          class: "text-purple-500 font-medium hover:underline"
        }, " Terms & Conditions ")
      ], -1))
    ]),
    (_unref(agreeError))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(agreeError)), 1))
      : _createCommentVNode("", true),
    (signupError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(signupError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(handleSignUp) && _unref(handleSignUp)(...args))),
      disabled: !_unref(agree),
      class: "w-full mt-3 text-lg bg-gradient-to-r from-purple-500 to-pink-400 text-white font-semibold py-2.5 rounded-xl hover:opacity-90 transition"
    }, " Sign up ", 8, _hoisted_5),
    _createElementVNode("p", _hoisted_6, [
      _cache[7] || (_cache[7] = _createTextVNode(" Already have an account? ", -1)),
      _createElementVNode("button", {
        class: "text-purple-500 font-semibold hover:underline ml-1",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/auth/signin')))
      }, " Sign in ")
    ])
  ]))
}
}

})